import React from "react";
import {connect} from "react-redux";
import {Row, Col, Button, Checkbox, DropdownButton, MenuItem} from "react-bootstrap";
import DatePicker from "react-bootstrap-date-picker";
import * as constants from "../../common/constants";
import {getUsefulDate, getUsefulDateWithYear, formatToServerDate, isEmptyString} from "../../common/utils";
import {setCanSaveDeliveryHold, setOnPermanentHold, setSubscriptionOnPermanentHold} from "../../actions/common/subscriptionSummaryActions";
import {setDirty} from '../../actions/common/commonActions';
import {updateVacations, deleteOrderAndUpdateVacation} from "../../actions/account/accountActions";
import {isFetching} from "../../actions/common/fetchingActions";
import ModalPopup from "../../components/common/ModalPopup";
import {translate} from '../../i18n/translate.js';
import {SubscriptionHoldReason} from "../../common/constants";
import styles from "../../css/account/accountDeliveryHoldPane.less"

class AccountDeliveryHoldPane extends React.Component {
    state = {
        vacationStart: this.props.vacationStart || [],
        vacationEnd: this.props.vacationEnd || [],
        updatePermanentHold: false,
        initIsSetPermanentHold: this.props.staticData.allowChangePermanentHold?this.props.isSetOnPermanentHold:undefined,
        requiredMakeUpData: this.props.requiredMakeUpData
    };

    componentDidUpdate(prevProps) {
        if (prevProps.requiredMakeUpData !== this.props.requiredMakeUpData) {
            this.setState({requiredMakeUpData: this.props.requiredMakeUpData});
        } else if (prevProps.requiredMakeUpData && !this.props.requiredMakeUpData) {
            this.setState({requiredMakeUpData: undefined});
        }
    }

    saveClicked = () => {
        if(this.state.updatePermanentHold) {
            this.props.setSubscriptionOnPermanentHold();
        } else {
            let makeUpSchedules = [], makeUpDates = [];
            if (this.state.requiredMakeUpData) {
                this.state.requiredMakeUpData.forEach(makeUpData => {
                    makeUpSchedules.push(makeUpData.schedule);
                    makeUpDates.push(makeUpData.date);
                })
            }
            this.props.updateVacations(this.state.vacationStart, this.state.vacationEnd, makeUpSchedules.length > 0 ? makeUpSchedules : undefined, makeUpDates.length > 0 ? makeUpDates : undefined);
        }
        this.props.setDirty(false);
        this.props.setCanSaveDeliveryHold(false);
    };

    isDateOnHoldPeriodCannotBeApplied = (date, startVacation, endVacation) => {
        if (date) {
            for (let i = 0; i < startVacation.length; i++) {
                if (startVacation[i].localeCompare(date) <= 0 && endVacation[i].localeCompare(date) >= 0) {
                    return true;
                }
            }
        }
    };

    isCancelWebOrder = (vacationStart, vacationEnd) => {
        return this.props.activeWebOrderKey && vacationStart <= this.props.nextDeliveryDate
            && vacationEnd >= this.props.nextDeliveryDate;
    };

    validateEnableSaving = (vacationStart, vacationEnd, isRemoved, validateMakeUp) => {
        this.props.setOnPermanentHold(false);
        const today = formatToServerDate(new Date());
        if ((this.props.vacationStart === undefined && vacationStart.length === 0 ||
            this.props.vacationEnd === undefined && vacationEnd.length === 0 || vacationStart.length !==  vacationEnd.length) && !isRemoved) {
            this.props.setCanSaveDeliveryHold(false);
            this.props.setDirty(true);
            this.setState({vacationStart, vacationEnd, errorMessage: undefined});
            return;
        }
        let errorMessage;
        let canSave = true;
        for(let index = 0; index < vacationStart.length; index++) {
            const currentVacationStart =  vacationStart[index];
            const currentVacationEnd =  vacationEnd[index];
            if ((!currentVacationStart || !currentVacationEnd)&&
                (currentVacationStart && isEmptyString(currentVacationEnd) ||
                (isEmptyString(currentVacationStart) && currentVacationEnd))) {
                canSave = false;
                break;
            }
            if (currentVacationStart > currentVacationEnd) {
                canSave = false;
                errorMessage = constants.DELIVERY_HOLD_DATES_END_BEFORE_START_DATE_ERROR;
                break;
            } else if (currentVacationEnd < today || (currentVacationStart < today && this.props.vacationStart !== undefined && !this.props.vacationStart.includes(currentVacationStart))) {
                canSave = false;
                errorMessage = constants.DELIVERY_HOLD_DATES_IN_PAST_ERROR;
                break;
            }
            else if (this.isDateOnHoldPeriodCannotBeApplied(this.props.farmStoreClosedEndDate, vacationStart, vacationEnd)) {
                canSave = false;
                errorMessage = constants.DELIVERY_HOLD_DATES_VACATION_CANNOT_BE_APPLIED + getUsefulDate(this.props.farmStoreClosedEndDate) + ".";
                break;
            } else if (vacationStart.length > 0 && vacationEnd.length > 0) {
                for (let i = 0; i < vacationStart.length; i++) {
                    const periodValueStart = currentVacationStart;
                    const periodValueEnd = currentVacationEnd;
                    if (i !== index) {
                        const otherPeriodValueStart = vacationStart.length >= i ? vacationStart[i] : null;
                        const otherPeriodValueEnd = vacationEnd.length >= i ? vacationEnd[i] : null;
                        if (!otherPeriodValueEnd && !otherPeriodValueStart) {
                            continue;
                        }
                        if ((periodValueStart <= otherPeriodValueStart &&
                                otherPeriodValueStart <= periodValueEnd)
                            || (periodValueStart <= otherPeriodValueEnd &&
                                otherPeriodValueEnd <= periodValueEnd)) {
                            canSave = false;
                            errorMessage = constants.DELIVERY_HOLD_OVERLAP_ERROR;
                            break;
                        }
                    }
                }
            }
            if (canSave && this.isCancelWebOrder(currentVacationStart, currentVacationEnd)) {
                if (
                    this.props.staticData.storePaymentMethods.includes(constants.PaymentMethod.BALANCE.key) ||
                    this.props.staticData.storePaymentMethods.includes(constants.PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key) ||
                    this.props.staticData.storePaymentMethods.includes(constants.PaymentMethod.PAYPAL_PREAPPROVE.key) ||
                    this.props.staticData.storePaymentMethods.includes(constants.PaymentMethod.ELECTRONIC_CHECK_PREAPPROVE.key)
                ) {
                    this.setState({showCancelOrderMessageRemoveIndex: index});
                } else {
                    this.setState({showCancelOrderMessageNoBalanceRemoveIndex: index});
                }
            }
        }
        if (this.state.requiredMakeUpData && validateMakeUp) {
            const missingDate = this.state.requiredMakeUpData.find(makeUpData => !makeUpData.date);
            canSave = canSave && !missingDate;
        }
        this.props.setDirty(true);
        this.props.setCanSaveDeliveryHold(canSave);
        if(this.props.staticData.allowChangePermanentHold) {
            this.props.setOnPermanentHold(false);
        }
        this.setState({vacationStart, vacationEnd, errorMessage});
    };

    validateDeletion = (vacations) => {
        if(vacations) {
            for (let index = 0; index < vacations.length; index++) {
                if (this.isDateOnHoldPeriodCannotBeApplied(this.props.farmStoreClosedEndDate, this.props.vacationStart, this.props.vacationEnd)) {
                    this.props.setCanSaveDeliveryHold(false);
                    this.setState({
                        vacationStart: this.props.vacationStart, vacationEnd: this.props.vacationEnd,
                        errorMessage: constants.DELIVERY_HOLD_DATES_VACATION_CANNOT_BE_APPLIED + getUsefulDate(this.props.farmStoreClosedEndDate) + "."
                    });
                    return false;
                }
            }
        }
        return true;
    };

    onRemoveButtonClick = (index) => {
        const vacationStart = this.state.vacationStart.slice();
        const vacationEnd = this.state.vacationEnd.slice();
        vacationStart.splice(index,1);
        vacationEnd.splice(index,1);
        this.clearMakeUpData();
        if(this.validateDeletion(this.props.vacationStart)) {
            this.validateEnableSaving(vacationStart, vacationEnd, true);
        }
    };

    handleFromChangeMobile = (index, event) => {
      this.handleFromChange(index, event.target.value);
    };

    handleFromChange = (index, value) => {
        const vacationStart = this.state.vacationStart.slice();
        if(isEmptyString(value)) {
            vacationStart.splice(index,1);
        } else {
            const val = value.split("T")[0];
            if(vacationStart.length >= index) {
                vacationStart[index] = val;
            } else {
                vacationStart.push(val);
            }
        }
        this.clearMakeUpData();
        if(this.validateDeletion(this.props.vacationStart)) {
            this.validateEnableSaving(vacationStart, this.state.vacationEnd);
        }
    };

    handleToChangeMobile = (index, event) => {
        this.handleToChange(index, event.target.value);
    };

    handleToChange = (index, value) => {
        const vacationEnd = this.state.vacationEnd.slice();
        if(isEmptyString(value)) {
            vacationEnd.splice(index,1);
        } else {
            const val = value.split("T")[0];
            if(vacationEnd.length >= index) {
                vacationEnd[index] = val;
            } else {
                vacationEnd.push(val);
            }
        }
        this.clearMakeUpData();
        if(this.validateDeletion(this.props.vacationEnd)) {
            this.validateEnableSaving(this.state.vacationStart, vacationEnd);
        }
    };

    clearMakeUpData = () => {
      this.setState({requiredMakeUpData: undefined});
    };

    getDatePicker = (vacationArray, index, onChangeFunction, onChangeMobileFunction) => {
        if(!this.props.clientViewPort.isXs) {
            return(<DatePicker placeholder=" " key={"from_" + index}
                        weekStartsOn={0}
                        disabled={this.props.isFetching || this.props.isSetOnPermanentHold}
                        value={vacationArray}
                        onChange={onChangeFunction.bind(this, index)}
                        clearButtonElement="x"
                        showTodayButton={true}
                        showClearButton={false}
                        calendarPlacement="top"/>);
        } else {
            return(<input type="date" name="from" onChange={onChangeMobileFunction.bind(this, index)}
                   className="account-delivery-hold-date-picker-from-mobile"
                   disabled={this.props.isFetching} value={vacationArray}/>)
        }
    };

    getDeliveryHold = (index) => {
        let vacationStart = "";
        let vacationEnd = "";
        if (this.state.vacationStart.length >= index) {
            if (this.state.vacationStart[index]) {
                vacationStart = this.state.vacationStart[index];
            }
        }
        if (this.state.vacationEnd.length >= index) {
            if (this.state.vacationEnd[index]) {
                vacationEnd = this.state.vacationEnd[index];
            }
        }
        return (<Row className="account-delivery-hold-date-picker-row" key={index}>
            <Col sm={1} xs={1} className="account-delivery-hold-date-from-label">{translate("From")}</Col>
            <Col sm={3} xs={5} className="account-delivery-hold-date-picker-from">
                {this.getDatePicker(vacationStart, index, this.handleFromChange, this.handleFromChangeMobile)}
            </Col>
            <Col sm={1} xs={1} className="account-delivery-hold-date-to-label">{translate("To")}</Col>
            <Col sm={3} xs={4} className="account-delivery-hold-date-picker-to">
                {this.getDatePicker(vacationEnd, index, this.handleToChange, this.handleToChangeMobile)}
            </Col>
            {
                (this.state.vacationStart || {}).length >= index && this.state.vacationStart[index] && this.state.vacationEnd[index] ?
                    <Col sm={1} xs={1}>
                        <div className="delivery-hold-remove"
                             name="btnDeliveryHoldRemove"
                             disabled={this.props.isFetching}
                             onClick={this.onRemoveButtonClick.bind(this, index)}/>
                    </Col> : undefined
            }
        </Row>);
    };

    getDatesSelections = () => {
        const deliveryHolds = [];
        for(let index=0;index<3;index++) {
            deliveryHolds.push(this.getDeliveryHold(index));
        }
        return (<div className="account-delivery-hold-inner-container">
                {deliveryHolds}
            </div>);
    };

    clearPartialDates = () => {
        let vacationStart = this.state.vacationStart;
        let vacationEnd = this.state.vacationEnd;
        let update = false;
        for (let i = vacationStart.length - 1; i > 0 ; i--) {
            if ((vacationStart[i] && !vacationEnd[i]) || (!vacationStart[i] && vacationEnd[i])){
                vacationStart.splice(i, 1);
                vacationEnd.splice(i, 1);
                update = true;
            }
        }
        if (update)
            this.setState({vacationStart, vacationEnd});
    };

    setOnPermanentHold = (val) => {
        this.props.setOnPermanentHold(val.target.checked);
        const today = formatToServerDate(new Date());
        if (this.props.farmStoreClosedEndDate && today.localeCompare(this.props.farmStoreClosedEndDate) <= 0) {
            let errorMessage = translate("cantUpdatePermanentHold").replace("{0}", getUsefulDate(this.props.farmStoreClosedEndDate) + ".");
            if(val.target.checked === this.state.initIsSetPermanentHold) {
                errorMessage = undefined
            }
            this.setState({
                errorMessage: errorMessage,
                updatePermanentHold: false
            });
            return;
        }
        if (val.target.checked && this.props.activeWebOrderKey) {
            if (this.props.staticData.storePaymentMethods.includes(constants.PaymentMethod.BALANCE.key)) {
                this.setState({showCancelOrderMessageRemoveIndex: 0});
            } else {
                this.setState({showCancelOrderMessageNoBalanceRemoveIndex: 0});
            }
            return;
        }
        this.props.setDirty(true);
        const updatePermanentHold = (val.target.checked && this.props.holdReason !== SubscriptionHoldReason.ADMIN) ||
            (!val.target.checked && this.props.holdReason === SubscriptionHoldReason.ADMIN);
        this.props.setCanSaveDeliveryHold(updatePermanentHold);
        this.setState({updatePermanentHold, errorMessage: undefined});
    };

    sendCancelSubscriptionRequest = () => {
        this.props.sendCancelSubscriptionRequest();
    }


    getSetPermanentHold = () => {
        if (this.props.staticData.allowChangePermanentHold) {
            return (<Row className="account-delivery-hold-date-picker-row">
                <Checkbox className="account-delivery-hold-date-from-cb"
                           checked={this.props.isSetOnPermanentHold }
                          onChange={this.setOnPermanentHold}
                          ref="isSetOnPermanentHold">
                    {translate("_setSubscriptionOnPermanentHold")}
                </Checkbox>
            </Row>);
        }
    };

    deleteDateOnPopupMessage = () => {
        this.onRemoveButtonClick(this.state.showCancelOrderMessageRemoveIndex);
        this.setState({showCancelOrderMessageRemoveIndex: undefined})
    };

    deleteDateNoBalanceOnPopupMessage = () => {
        this.onRemoveButtonClick(this.state.showCancelOrderMessageNoBalanceRemoveIndex);
        this.setState({showCancelOrderMessageNoBalanceRemoveIndex: undefined})
    };

    deleteOrder = () => {
        if (this.state.deleteOrderInProgress)
            return;
        this.setState({deleteOrderInProgress: true});
        this.props.deleteOrderAndUpdateVacation(this.state.vacationStart, this.state.vacationEnd);
        this.clearPartialDates();
        const that = this;
        setTimeout( function () {
            that.setState({showCancelOrderMessageRemoveIndex: undefined, deleteOrderInProgress: false});
        },1000);
    };

    setRequiredMakeUpScheduleDate = (index, date) => {
        let requiredMakeUpData = this.state.requiredMakeUpData;
        requiredMakeUpData[index].date = date;
        this.setState({requiredMakeUpData});
        this.validateEnableSaving(this.state.vacationStart, this.state.vacationEnd, false, true)
    };

    getSharesTitleBySchedule = (schedule) => {
        let title = [];
        for (let i = 0 ; i < this.props.shareItems.length ; i++) {
            const share = this.props.shareItems[i];
            if (share.selectedSchedule === schedule) {
                title.push(<div>{(share.quantity === 1 ? '' : share.quantity + ' ') + share.title}</div>);
            }
        }
        return title;
    };

    renderRequiredMakeUpDataRow = (makeUpData, index) => {
        const title = this.getSharesTitleBySchedule(makeUpData.schedule);
        let dates = makeUpData.dates.map((date, index) => {
            return(<MenuItem key={`menuItem${index}`} eventKey={date}>{getUsefulDateWithYear(date)}</MenuItem>)
        });

        const dropdownTitle = this.state.requiredMakeUpData[index].date ? getUsefulDateWithYear(this.state.requiredMakeUpData[index].date) : '';
        return (
            <Row index={index} key={`makeupRow${index}`} className="account-delivery-holds-make-up-schedule-row">
                <Col sm={6} xs={6} className="account-delivery-holds-make-up-subscription">{title}</Col>
                <Col sm={4} xs={4}>
                    <DropdownButton dropup className="account-delivery-holds-make-up-date" noCaret
                                    title={dropdownTitle}
                                    id={'dropdownDate' + index}
                                    onSelect={(value) => {this.setRequiredMakeUpScheduleDate(index, value)}}
                                    key={this.state.requiredMakeUpData[index].date}
                    >
                        {dates}
                    </DropdownButton>
                </Col>
            </Row>
        )
    };

    renderRequiredMakeUpData = () => {
        if (this.state.requiredMakeUpData) {
            return (
                <div className="account-delivery-holds-make-up-container">
                    <div className="account-delivery-holds-make-up-title">Make Up Dates - Please choose dates</div>
                    <Row key={'header'} className="account-delivery-holds-make-up-header-row">
                        <Col sm={6} xs={6} className="account-delivery-holds-make-up-header-label">Subscription</Col>
                        <Col sm={4} xs={4} className="account-delivery-holds-make-up-header-label">Date</Col>
                    </Row>
                    {this.state.requiredMakeUpData.map(((makeUpData, index) => {
                        return (this.renderRequiredMakeUpDataRow(makeUpData, index));
                    }))}
                </div>
            )
        }
    };

    render() {
        return (<fieldset disabled={this.props.isFetching || this.props.isPreview}>
            <div className="account-delivery-hold-box">
                {this.props.clientViewPort.isXs ?
                    <div className="account-header-title-container">
                        <div className="account-header-title">Delivery Hold</div>
                        <Button disabled={!this.props.canSaveDeliveryHold}
                                onClick={this.saveClicked}
                                type="submit"
                                className={"submit-order button account-delivery-hold-save-btn" + (this.props.isFetching ? " loading" : "")}
                                bsStyle="primary">{translate("Save")}</Button>
                    </div> : undefined
                }
                <Row className="account-delivery-hold-description-container">
                    <Col md={10} sm={9} className="account-delivery-hold-title">{translate('VacationHoldTopLine')}<br/>
                        <span className="account-delivery-hold-title-distribution">{this.props.nextDeliveryDate && (translate('VacationHold2ndLine') + ' ' + getUsefulDate(this.props.nextDeliveryDate))}</span></Col>
                    {!this.props.clientViewPort.isXs ?
                        <Col md={2} sm={3}>
                            <Button disabled={!this.props.canSaveDeliveryHold}
                                    onClick={this.saveClicked}
                                    type="submit"
                                    className={"submit-order button account-delivery-hold-save-btn" + (this.props.isFetching ? " loading" : "")}
                                    bsStyle="primary">{translate("Save")}</Button>
                        </Col> : undefined
                    }
                </Row>
                {this.getDatesSelections()}
                {this.getSetPermanentHold()}
                {this.renderRequiredMakeUpData()}
                <div className="account-delivery-bottom-container">
                {
                    !this.state.errorMessage ? undefined :
                        <div className="delivery-holds-error" dangerouslySetInnerHTML={{__html:this.state.errorMessage}}/>
                }
                </div>
            </div>
            {this.state.showCancelOrderMessageRemoveIndex !== undefined?
                <ModalPopup
                    message={constants.DELIVERY_HOLD_DATES_CANCEL_ORDER + (this.props.staticData.hasRecurringItems ? constants.DELIVERY_HOLD_RECURRING_ORDERS_ALERT : '')}
                    right={{text:'Save', callback:this.deleteOrder}}
                    left={{text:"Cancel", callback:this.deleteDateOnPopupMessage}}/>
                : undefined
            }
            {this.state.showCancelOrderMessageNoBalanceRemoveIndex !== undefined?
                <ModalPopup
                    message={constants.DELIVERY_HOLD_DATES_BLOCK_DATE_NO_BALANCE}
                    middle={{text:"Cancel", callback:this.deleteDateNoBalanceOnPopupMessage}}/>
                : undefined
            }
        </fieldset>);
    }
}

const mapStateToProps = (state) => {
    const summary = state.summary || {};

    return {
        staticData: state.staticData,
        clientViewPort: state.clientViewPort,
        vacationStart: summary.vacationStart,
        vacationEnd: summary.vacationEnd,
        isFetching: isFetching(state, constants.FetchingTypes.UPDATE_VACATION),
        isPreview: (state.staticData || {}).isPreview,
        canSaveDeliveryHold: summary.canSaveDeliveryHold,
        isStoreOpen: summary.isStoreOpen,
        nextDeliveryDate: summary.nextDeliveryDate,
        activeWebOrderKey: summary.activeWebOrderKey,
        farmStoreClosedEndDate: summary.farmStoreClosedEndDate,
        isSetOnPermanentHold : summary.isSetOnPermanentHold,
        holdReason: summary.holdReason,
        shareItems: summary.shareItems,
        requiredMakeUpData: summary.requiredMakeUpData,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateVacations: (vacationStart, vacationEnd, makeUpSchedules, makeUpDates) => {
            dispatch(updateVacations(vacationStart, vacationEnd, makeUpSchedules, makeUpDates));
        },
        setDirty: (isDirty) => {
            dispatch(setDirty(isDirty));
        },
        setCanSaveDeliveryHold: (canSaveDeliveryHold) => {
            dispatch(setCanSaveDeliveryHold(canSaveDeliveryHold));
        },
        deleteOrderAndUpdateVacation: (vacationStart, vacationEnd) => {
            dispatch(deleteOrderAndUpdateVacation(vacationStart, vacationEnd));
        },
        setOnPermanentHold:(isSetOnPermanentHold) => {
            dispatch(setOnPermanentHold(isSetOnPermanentHold));
        },
        setSubscriptionOnPermanentHold: () => {
            dispatch(setSubscriptionOnPermanentHold());
        }
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(AccountDeliveryHoldPane);



// WEBPACK FOOTER //
// ./src/components/account/AccountDeliveryHoldPane.js